import { useLayoutEffect, useRef, useState } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { completeSearchAttempt, handOffSearchAttempt, searchProperties, startSearchAttempt, takeSearchAttempt, type SearchAttempt, type SearchMethod } from '../utils/readerTelemetry';

export function useReaderSearchTelemetry(enabled: boolean, query: string, descriptionId: string | null) {
  const location = useLocation();
  const navigation = useNavigationType();
  const current = useRef<SearchAttempt | null>(null);
  const [, render] = useState(0);
  const lastLocation = useRef<string | null>(null);
  useLayoutEffect(() => {
    if (!enabled || lastLocation.current === location.key) return;
    lastLocation.current = location.key;
    const transferred = navigation !== 'POP' ? takeSearchAttempt(location.state?.readerAttemptId) : null;
    current.current = transferred || startSearchAttempt('url', '', new URLSearchParams(location.search).get('hours') === '72' ? 72 : 24, descriptionId);
    render(n => n + 1);
  }, [location.key, enabled]); // Each location starts once it is ready; subsequent updates never initiate another search

  const begin = (method: SearchMethod, text: string, windowHours: 24 | 72, desc?: string | null) => {
    const attempt = startSearchAttempt(method, text, windowHours, desc);
    current.current = attempt;
    render(n => n + 1);
    return attempt;
  };
  const finish = (runId: string | null, count: number | null, attempt = current.current) => completeSearchAttempt(attempt, runId, count, query);
  return { current, begin, finish, navigationState: handOffSearchAttempt,
    properties: current.current ? { ...searchProperties(current.current), query: current.current.query || query } : {} };
}
